import { render, staticRenderFns } from "./mensagem_tela_inicial.vue?vue&type=template&id=5f49b02e&scoped=true"
import script from "./mensagem_tela_inicial.vue?vue&type=script&lang=js"
export * from "./mensagem_tela_inicial.vue?vue&type=script&lang=js"
import style0 from "./mensagem_tela_inicial.vue?vue&type=style&index=0&id=5f49b02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49b02e",
  null
  
)

export default component.exports